import { gql } from '@apollo/client'

const BATCH_UPLOAD_SUBSCRIPTION = gql`
subscription BatchUploadSubscription {
  batchUploaderSubscription {
   type
   message
  }
}`

export { BATCH_UPLOAD_SUBSCRIPTION }
